<div class="widget-content">
  <h3 class="widget-title">{{ 'Visit Counter' | translate }}</h3>
  @if (widgetData.length > 0) {
    <p class="info">{{'Drag to the right to schedule' | translate }}</p>
  }
  <div class="widget-table" id="visitCounterWidgetTable">
    <div class="widget-row widget-header">
      <div class="widget-row__item">{{ widgetHeaderData[0] | async }}</div>
      <div class="widget-row__item">{{ widgetHeaderData[1] | async }}</div>
      <div class="widget-row__item">{{ widgetHeaderData[2] | async }}</div>
    </div>
    <div class="widget-data">
      @for (row of widgetData; track row; let i = $index) {
        <div class="widget-row"
          [ngClass]="calculateClasses(row)"
          >
          <div class="widget-row__item fc-event"  id="store-{{i}}" [attr.data-event]="getRowDetails(row)" matTooltip={{row.storeName}}>{{ needsTruncation(row.storeName)? truncate(row.storeName):(row.storeName) }} </div>
          <div class="widget-row__item" id="daysLeft-{{i}}">{{ row.daysLeft }} </div>
          <div class="widget-row__item" id="mtd-{{i}}">{{ row.visitDetails }}</div>
        </div>
      }
    </div>
  </div>

</div>
